/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listNotifications.defs'
export { main as default } from './listNotifications.defs'
